package presentation.screens.business.inventory.sub_category.select

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.ui.Modifier
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.navigator.LocalNavigator
import component.empty.EmptyData
import component.loader.AppLoader
import component.navigation.TopNavBar
import feature.productSubCategory.viewModel.ProductSubCategoryViewModel
import presentation.screens.business.inventory.sub_category.component.SelectProductSubCategoryCard
import presentation.screens.business.inventory.sub_category.create.CreateSubCategoryScreen
import theme.ThemeColor

class SelectSubCategoryScreen : Screen {
    @Composable
    override fun Content() {
        val navigator = LocalNavigator.current
        val viewModel = ProductSubCategoryViewModel()
        val allCategories = viewModel.allSubCategory.collectAsState()
        val selectedSubCategory = viewModel.selectedSubCategory.collectAsState()
        LaunchedEffect(key1 = Unit) {
            viewModel.fetchAll()
        }
        Column(
            modifier = Modifier.fillMaxSize()
                .background(ThemeColor.shared().defaultBakground)
        ) {
            TopNavBar(title = "Sub Category", onBackPress = {
                navigator?.pop()
            }, onClickAdd = {
                navigator?.push(CreateSubCategoryScreen())
            })
            AppLoader(viewModel)
            if (allCategories.value.isNotEmpty()) {
                LazyColumn {
                    items(count = allCategories.value.count()) { index ->
                        SelectProductSubCategoryCard(
                            subCategory = allCategories.value[index],
                            selectedSubCategory.value,
                            onClick = {
                                viewModel.setSelectedSubCategory(it)
                                navigator?.pop()
                            })
                    }
                }
            } else {
                EmptyData(viewModel = viewModel) {
                    viewModel.loadSubCategory()
                }
            }
        }
    }
}